export const version = "hdnode/5.6.1";
//# sourceMappingURL=_version.js.map